/**
 * 부서 기본정보 컬럼 정의
 * DEP_BASIC 화면 전용 컬럼 정의
 */

import { CreateColumn } from '../../../../Services/agGrid/createColumn';

/**
 * 부서정보 컬럼 정의 생성
 * @param {object} props - 컴포넌트 props
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs1 = (props) => {
  return [
    // 체크박스 컬럼 (NO 컬럼)
    CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
      checkboxProps: {
        DeleteNewRow: props.DeleteNewRow1,
        RestoreRow: props.RestoreRow,
        gridRef: props.gridRef1,
        rowData: props.rowData,
        selectedRowNosRef: props.selectedRowNosRef,
        lastCheckedIndexRef: props.lastCheckedIndexRef,
        handleRowSelection: props.handleRowSelection,
        dispatchGrid: props.dispatchGrid,
        gridState: props.gridState,
      },
      maxWidth: 80,
    }),
    // 본부 컬럼
    CreateColumn('depNm1', '본부', 'left', 200, false, false, false, 'text', {
      minWidth: 200,
      flex: 1,
    }),
    // 부서 컬럼
    CreateColumn('depNm2', '부서', 'left', 100, false, false, false, 'text', {
      minWidth: 100,
      flex: 1,
    }),
    // 팀 컬럼
    CreateColumn('depNm3', '팀', 'left', 200, false, false, false, 'text', {
      minWidth: 200,
      flex: 1,
    }),
    // 파트 컬럼
    CreateColumn('depNm4', '파트', 'left', 200, false, false, false, 'text', {
      minWidth: 200,
      flex: 1,
    }),
    // 부서코드 컬럼 (숨김)
    CreateColumn('depCd', '부서코드', 'left', 100, false, false, true, 'text', {
      minWidth: 100,
    }),
  ];
};

/**
 * 대표자 목록 그리드 컬럼 정의 생성
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs2 = () => {
  return [
    // 체크박스 컬럼 (NO 컬럼)
    CreateColumn('no', 'NO', 'right', 80, false, false, false, 'checkbox', {
      maxWidth: 80,
    }),
    // ID 컬럼
    CreateColumn('coId', 'ID', 'left', 120, false, false, false, 'text', {
      flex: 1,
    }),
    // 이름 컬럼
    CreateColumn('name', '이름', 'left', 200, false, false, false, 'text', {
      flex: 1,
    }),
    // 전화번호 컬럼
    CreateColumn(
      'tel',
      '전화번호',
      'center',
      150,
      false,
      false,
      false,
      'phone',
      {
        minWidth: 150,
        flex: 1,
      }
    ),
    // 생년월일 컬럼
    CreateColumn(
      'birth',
      '생년월일',
      'center',
      150,
      false,
      false,
      false,
      'date',
      {
        minWidth: 150,
        flex: 1,
      }
    ),
  ];
};

const columnDefs = {
  getColumnDefs1,
  getColumnDefs2,
};

export default columnDefs;
